import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import { Container } from '@/components/layout';
import Icon from '@/components/icons/Icon';

function GetInTouch() {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        paddingTop: { xs: theme.spacing(10), lg: theme.spacing(13) },
        paddingBottom: theme.spacing(13),
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <Container>
        <Stack
          sx={{
            gap: { xs: theme.spacing(11), md: theme.spacing(16.75) },
            flexDirection: { xs: 'column', lg: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Stack
            sx={{
              flex: 1,
            }}
          >
            <Stack
              sx={{
                gap: theme.spacing(3.5),
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: theme.spacing(3),
              }}
            >
              <Icon
                iconName="briefcase"
                style={{
                  color: theme.palette.primary[400],
                  width: '36px',
                  height: '36px',
                }}
              />
              <Typography
                fontSize="2.375rem !important"
                lineHeight="1.2 !important"
                variant="h2"
                fontWeight="700"
                color={theme.palette.common.white}
              >
                We Are Hiring
              </Typography>
            </Stack>

            <Typography
              fontSize="1.125rem !important"
              lineHeight="1.46 !important"
              variant="body2"
              color={theme.palette.grey[100]}
              marginBottom={theme.spacing(6)}
            >
              Join OneVillage and help us transform health and well-being for
              individuals and businesses. We’re looking for passionate, driven
              people to make an impact and grow with us. Apply today and be part
              of our mission to empower healthier lives.
            </Typography>

            <Box sx={{ marginTop: 'auto' }}>
              <Box
                component="a"
                href="https://www.linkedin.com/company/myonevillage/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  py: theme.spacing(3.5),
                  backgroundColor: theme.palette.common.white,
                  minWidth: 'fit-content',
                  width: '100%',
                  px: theme.spacing(6),
                  borderRadius: theme.spacing(5.5),
                }}
              >
                <Typography
                  fontSize="1rem !important"
                  lineHeight="1rem !important"
                  variant="body2"
                  color="#52545F"
                  textAlign="center"
                >
                  Join Our Team
                </Typography>
              </Box>
            </Box>
          </Stack>

          <Box
            component="div"
            sx={{
              width: '1px',
              height: 'auto',
              backgroundColor: '#91C7CB',
              display: { xs: 'none', lg: 'block' },
            }}
          />

          <Stack
            sx={{
              flex: 1,
            }}
          >
            <Stack
              sx={{
                gap: theme.spacing(3.5),
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: theme.spacing(3),
              }}
            >
              <Icon
                iconName="chat"
                style={{
                  color: theme.palette.primary[400],
                  width: '36px',
                  height: '36px',
                }}
              />
              <Typography
                fontSize="2.375rem !important"
                lineHeight="1.2 !important"
                variant="h2"
                fontWeight="700"
                color={theme.palette.common.white}
              >
                Get in Touch
              </Typography>
            </Stack>

            <Typography
              fontSize="1.125rem !important"
              lineHeight="1.46 !important"
              variant="body2"
              color={theme.palette.grey[100]}
              marginBottom={theme.spacing(6)}
            >
              We’d love to connect with you. If you have any questions, complete
              this form and we’ll get back to you as soon as we can.
            </Typography>

            <Box sx={{ marginTop: 'auto' }}>
              <Box
                component="a"
                href="mailto:support@onevillage.io"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  py: theme.spacing(3.5),
                  backgroundColor: theme.palette.common.white,
                  minWidth: 'fit-content',
                  width: '100%',
                  px: theme.spacing(6),
                  borderRadius: theme.spacing(5.5),
                }}
              >
                <Typography
                  fontSize="1rem !important"
                  lineHeight="1rem !important"
                  variant="body2"
                  color="#52545F"
                  textAlign="center"
                >
                  Contact Us
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
}

export default GetInTouch;
